import { render } from "./SearchSamples.vue?vue&type=template&id=1b9d0f8a&scoped=true"
import script from "./SearchSamples.vue?vue&type=script&lang=js"
export * from "./SearchSamples.vue?vue&type=script&lang=js"

import "./SearchSamples.vue?vue&type=style&index=0&id=1b9d0f8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9d0f8a"]])

export default __exports__